import { lazy, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { GetPlayersResponse } from 'services/players';

import styles from './landing-layout.module.scss';

const SubHeader = lazy(
	() => import('core/generic/components/navigation/sub-header')
);
const CardSlider = lazy(
	() => import('core/generic/components/general/card-slider')
);
const PlayerCard = lazy(
	() => import('core/generic/components/cards/player-card')
);

type LandingLayoutProps = {
	team: string;
	data?: GetPlayersResponse;
};

export const LandingLayout = ({ team, data }: LandingLayoutProps) => {
	const { t } = useTranslation();
	const navigation = useMemo(
		() => [
			{
				url: '/mens',
				label: t('global.sub_header:mens_team_label', "Men's team"),
			},
			{
				url: '/womens',
				label: t('global.sub_header:womens_team_label', "Women's team"),
			},
			{
				url: '/eds',
				label: t('global.sub_header:eds_team_label', 'EDS'),
			},
			{
				url: '/academy',
				label: t('global.sub_header:academy_team_label', 'Academy'),
			},
			{
				url: '/esports',
				label: t('global.sub_header:esports_team_label', 'Esports'),
			},
		],
		[t]
	);
	const partner = useMemo(
		() => ({
			label: t(
				'global.sub_header:sponsor_side_text',
				'brought to you by'
			),
			logo: {
				alt: 'Puma',
				url: 'https://www.mancity.com/dist/images/puma_crest.png',
			},
		}),
		[t]
	);
	const activeIndex = navigation.findIndex((item) => item.url === `/${team}`);
	return (
		<>
			<SubHeader
				title={t('players_players.header_players', 'Players')}
				navigation={navigation}
				partner={partner}
				activeUrl={navigation[activeIndex]?.url}
				className={styles['container']}
			/>
			<div className={`container ${styles['landing-container']}`}>
				<div className="row">
					{data && (
						<>
							{data.body.map((position, index) => (
								<div
									className="col-12"
									key={`${team}-${position}-${index}`}
								>
									<CardSlider
										title={t(
											`players_players.heading_${position.name}`,
											position.name
										)}
										gridFrom="large"
									>
										{position.players.map((player) => (
											<li key={player.id}>
												<PlayerCard
													playerData={player}
													backgroundImage={
														player.isManager
															? data.cityTeamInfo
																	.teamPlayerImages
																	?.managerCardImage
															: data.cityTeamInfo
																	.teamPlayerImages
																	?.playerCardImage ||
																data
																	.cityTeamInfo
																	.playerCardImage
													}
												/>
											</li>
										))}
									</CardSlider>
								</div>
							))}
						</>
					)}
				</div>
			</div>
		</>
	);
};
